import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';
import { liveQuery } from 'dexie';
import { db } from '@stores/indexdb.store';

@Component({
	selector: 'vex-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
	@Input() customTemplate: TemplateRef<any>;
	public menuButtons = [];
	mobileMenu$;

	constructor(private navigationService: NavigationService, private router: Router) {}

	ngOnInit() {
		var menuItems = [];
		this.navigationService.items.forEach(i => {
			if (i.type == 'link') {
				menuItems.push(i);
			} else if (i.type == 'subheading') {
				i.children.forEach(s => {
					if (s.type == 'link') {
						menuItems.push(s);
					}
				});
			}
		});

		this.mobileMenu$ = liveQuery(async () => {
			return await db.appSettings
				.where('key')
				.equals('mobileMenu')
				.first(appSetting => {
					var menuButtons = [];
					appSetting.value.forEach(m => {
						var menu = menuItems.find(mi => mi.label == m);
						if (menu) {
							menuButtons.push(menu);
						}
					});
					return menuButtons;
				});
		});
	}

	public activateMenu(item) {
		this.router.navigate([item.route], item.routerLinkActiveOptions);
	}

	ngOnDestroy(): void {}
}
